// extracted by mini-css-extract-plugin
module.exports = {"container":"x4xoneGomZrZhkGszT9z9Q==","details":"_6uUF2kWw4GMs7k2vbKKGBQ=="};